<template>
  <div>
    <!-- :get-form-data="fromData" -->
    <list
      row-key="PurchaseDemandId"
      ref="list"
      unit="采购需求"
      :page="page"
      :show-query="true"
      :get-data-func="api.list"
      @reset="$refs.picker.clear()"
      :temp-params="tempParams"
      urlHash="production/clothmanagement/demand"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="table">
        <slot name="column"></slot>
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from '@/mixins/trend/list'
import list from '@/components/common/trendsTable/list'
import tableColumn from '@/data/production/clothmanagement/demand/list.json'
import tableParam from '@/data/production/clothmanagement/demand/query.json'

export default {
  mixins: [listMixin],
  components: { list },
  provide() {
    return {
      IsDefaultMonth: false
    }
  },
  data() {
    return {
      api: require('@/api/pu/puPurchaseDemand').default,
      params: {
        OrderCode: '',
        // DocTime: "",
        isGenerate: '',
        StartDate: '',
        EndDate: ''
      },
      tempParams: {}
    }
  },
  activated() {
    this.getRouterInfo()
  },
  methods: {
    getRouterInfo() {
      if (this.$router.history.current.params) {
        // this.params.Id= this.$router.history.current.params.DemandId
        this.tempParams.Id = {
          paramValueType: 'resetParamValue',
          value: this.$router.history.current.params.DemandId,
          isReset: true
        }

        this.tempParams.SourceDocId = {
          paramValueType: 'resetParamValue',
          value: this.$router.history.current.params.SourceDocId,
          isReset: true
        }

        this.tempParams.SaOrderNo = {
          paramValueType: 'resetParamValue',
          value: this.$router.history.current.params.SaOrderNo,
          isReset: true
        }

        this.tempParams.SourceType = {
          paramValueType: 'resetParamValue',
          value: this.$router.history.current.params.SourceType,
          isReset: true
        }

        this.$refs.list.getData()
      }
    },
    delRange(ids) {
      this.api.delete({ ids }).then(res => {
        if (res.Code == 0) {
          this.$message.success('删除成功')
          this.reload()
        } else {
          this.$message.error(res.Msg)
        }
      })
    }
  }
}
</script>
